// Maps alarm metric display names to healthSettings field structure
// Used to cross-reference alarm metric values with configured thresholds
export const METRIC_TO_HEALTH_FIELD = {
  Latency: {
    prefix: 'latency',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'pingLatency',
    metricUnitKey: 'latencyMetricUnit'
  },
  Jitter: {
    prefix: 'jitter',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'pingJitter',
    metricUnitKey: 'jitterMetricUnit'
  },
  'Packet Loss': { prefix: 'packetLoss', unit: '%', divisor: 1, disabledKey: 'pingPacketLoss' },
  'HTTP Latency': {
    prefix: 'httpLatency',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'httpLatency',
    metricUnitKey: 'httpLatencyMetricUnit'
  },
  'DNS Latency': {
    prefix: 'dnsLatency',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'dnsLatency',
    metricUnitKey: 'dnsLatencyMetricUnit'
  },
  dnsLatency: {
    prefix: 'dnsLatency',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'dnsLatency',
    metricUnitKey: 'dnsLatencyMetricUnit'
  },
  dnsResolutionTime: {
    prefix: 'dnsLatency',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'dnsLatency',
    metricUnitKey: 'dnsLatencyMetricUnit'
  },
  'DNS Resolution Time': {
    prefix: 'dnsLatency',
    unit: 'ms',
    storedUnit: 'µs',
    divisor: 1000,
    disabledKey: 'dnsLatency',
    metricUnitKey: 'dnsLatencyMetricUnit'
  },
  Throughput: { prefix: 'throughput', unit: 'Mbps', divisor: 1, inverted: true, disabledKey: 'throughputBandwidth' },
  'Certificate Expiry': {
    prefix: 'certExpiry',
    unit: 'days',
    divisor: 1,
    inverted: true,
    disabledKey: 'httpCertExpiry'
  },
  Reachability: { prefix: 'reachability', unit: '%', divisor: 1, inverted: true }
};

// Maps healthSettings field prefix to the health_ts rolling stat fields
// Note: jitter uses `rolling_std_jitter` (not `rolling_stddev_jitter`) — inconsistent naming from syngest
export const ROLLING_STAT_FIELDS = {
  latency: { avg: 'rolling_avg_latency', stddev: 'rolling_stddev_latency' },
  jitter: { avg: 'rolling_avg_jitter', stddev: 'rolling_std_jitter' },
  httpLatency: { avg: 'rolling_avg_latency', stddev: 'rolling_stddev_latency' },
  dnsLatency: { avg: 'rolling_avg_latency', stddev: 'rolling_stddev_latency' },
  throughput: { avg: 'rolling_avg_throughput_bandwidth', stddev: 'rolling_stddev_throughput_bandwidth' }
};

// Metrics where lower values trigger alarms (below threshold = unhealthy)
// For these: warning symbol is '<', critical symbol is '<'
// For normal metrics: warning symbol is '>', critical symbol is '>'
export const INVERTED_METRICS = new Set(['throughput', 'certExpiry', 'reachability']);

// Ordered list of metrics per task type, for display in config drawer/sidebar
// Each entry: { metric: key in METRIC_TO_HEALTH_FIELD, label: display label }
const PING_METRICS = [
  { metric: 'Latency', label: 'Ping Latency' },
  { metric: 'Jitter', label: 'Ping Jitter' },
  { metric: 'Packet Loss', label: 'Ping Packet Loss' }
];

const HTTP_METRICS = [
  { metric: 'HTTP Latency', label: 'HTTP Latency' },
  { metric: 'Certificate Expiry', label: 'Certificate Expiry' }
];

const DNS_METRICS = [{ metric: 'DNS Latency', label: 'DNS Response Time' }];

const THROUGHPUT_METRICS = [{ metric: 'Throughput', label: 'Throughput Bandwidth' }];

const BGP_METRICS = [{ metric: 'Reachability', label: 'Reachability' }];

// Returns ordered list of metric descriptors applicable to a test based on its tasks and type
export function getMetricsForTest(tasks, testType) {
  const metrics = [];

  if (tasks.includes('ping') || tasks.includes('knock')) {
    metrics.push(...PING_METRICS);
  }

  if (testType === 'agent' && tasks.includes('throughput')) {
    metrics.push(...THROUGHPUT_METRICS);
  }

  if (tasks.includes('http') || tasks.includes('page-load')) {
    metrics.push(...HTTP_METRICS);
  }

  if (tasks.includes('dns')) {
    metrics.push(...DNS_METRICS);
  }

  if (tasks.includes('bgp-monitor') || testType === 'bgp-monitor') {
    metrics.push(...BGP_METRICS);
  }

  return metrics;
}
